import { Injectable } from '@angular/core';
import { CanComponentDeactivate } from '../routing/can-deactivate.guard';

@Injectable({
    providedIn: 'root'
})
export class DirtyFormRegistryService {

    private readonly components = new Set<CanComponentDeactivate>();

    public register(component: CanComponentDeactivate): void {
        this.components.add(component);
    }

    public unregister(component: CanComponentDeactivate): void {
        this.components.delete(component);
    }

    /** True when `component` is already asked by confirmAllCanDeactivate() — callers must not ask it again. */
    public isRegistered(component: CanComponentDeactivate): boolean {
        return this.components.has(component);
    }

    /**
     * Awaits every currently-mounted leaf's own canDeactivate() in turn, short-circuiting on the first
     * `false`. Sequential (not Promise.all) so at most one leave-confirmation modal is ever shown at a
     * time, even if more than one dirty leaf happens to be mounted.
     */
    public async confirmAllCanDeactivate(): Promise<boolean> {
        for (const component of this.components) {
            const canLeave = await component.canDeactivate();
            if (!canLeave) {
                return false;
            }
        }
        return true;
    }
}
